import React from "react";
import { HelpCircle } from "design_system/Icon";
import { NavBar as DSNav } from "widgets/NavBar";
import { Text } from "design_system/Text";
import { Color } from "../../utils/enums";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

export const getHelpCenterUrl = (queryParams: URLSearchParams) => {
    const baseUrl = "/help-center/";
    return queryParams.toString() ? `${baseUrl}?${queryParams.toString()}` : baseUrl;
};

interface HelpCenterCtaV3Props {
    className?: string;
}
export const HelpCenterCtaV3 = ({ className = "ml-auto" }: HelpCenterCtaV3Props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const helpCenterUrl = getHelpCenterUrl(urlParams);
    return (
        <DSNav.TopBar.Link
            leadingIcon={<HelpCircle color={Color.WHITE} aria-hidden="true" />}
            className={className}
            href={helpCenterUrl}
            onClick={() => recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.GET_HELP_BTN)}
        >
            <Text>{gettext("Get help")}</Text>
        </DSNav.TopBar.Link>
    );
};
